<div class="card-content" (click)="selectThread()">
  <div class="email-header">
    <div class="flex-start-container">
      <span class="email-username">{{ email.from_email.name }}</span>
    </div>
    <div class="flex-end-container">
      @if (email.thread_messages_count > 0) {
        <div class="reply-container">
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="14"
            height="15"
            viewBox="0 0 14 15"
            fill="none"
          >
            <path
              d="M5.25008 8.66667L2.91675 6.33333L5.25008 4"
              stroke="#151C29"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
            <path
              d="M2.91675 6.3335H9.33341C9.95225 6.3335 10.5457 6.57933 10.9833 7.01691C11.4209 7.4545 11.6667 8.04799 11.6667 8.66683C11.6667 9.28567 11.4209 9.87916 10.9833 10.3167C10.5457 10.7543 9.95225 11.0002 9.33341 11.0002H8.75008"
              stroke="#151C29"
              stroke-width="1.5"
              stroke-linecap="round"
              stroke-linejoin="round"
            />
          </svg>
          <span style="font-size: 12px; font-weight: 700; margin-top: 1px">{{
            email.thread_messages_count
          }}</span>
        </div>
      }
      <span class="email-time" [tooltip]="email.last_message_received_timestamp | amDateFormat:'MM/DD/YYYY HH:mm'">{{
        email.last_message_received_timestamp | amTimeAgo
      }}</span>
      @if (isPinned) {
        <ds-pin
          [hovering]="true"
          [type]="pinTypeThread"
          [identifier]="email?.uuid"
          [model]="email"
          [pin]="pin"
          [company]="{ id: email?.client_company }"
        />
      }
    </div>
  </div>
  <span style="color: black; font-size: 14px">{{ email.subject }}</span>
  <div class="email-content">
    {{ email.snippet }}
  </div>
</div>
